"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const EventEmitter = require("wolfy87-eventemitter");
const LogManager_1 = require("../../../Log/LogManager");
const TypeScriptUtils_1 = require("../../../Common/TypeScriptUtils");
const DomainEvent_1 = require("../DomainEvent");
const IEventHub_1 = require("../IEventHub");
const ProtocolConstant_1 = require("./../../../Protocol/ProtocolConstant");
class ClientEventHub {
    constructor(langyan) {
        this._logger = LogManager_1.logManager.GetLogger("ClientEventHub");
        this._localUsername = "";
        this._eventHandlerDic = new Map();
        this._subjects = new Map();
        this.errorOccurred = new EventEmitter();
        this._langyan = langyan;
    }
    async initAsync(userId, username) {
        //訂閱Langyan的channel
        await this._langyan.subscribeAsync(ClientEventHub.getEventChannelName(username), async (evt) => this.eventChannelHandler(evt));
        this._localUsername = username;
    }
    async terminateAsync() {
        if (TypeScriptUtils_1.isNullOrEmpty(this._localUsername))
            return;
        //取消Local event的所有訂閱
        this._subjects.forEach((sub, key, map) => {
            sub.unsubscribe(); //clear all observer.
        });
        this._subjects.clear();
        //清掉ApplicationService註冊的EventHandler
        this._eventHandlerDic.clear();
        //取消在Langyan訂閱的Channel
        await this._langyan.unSubscribeAsync(ClientEventHub.getEventChannelName(this._localUsername));
        this.errorOccurred.removeAllListeners();
        this._localUsername = "";
    }
    async publishAsync(evt, receivers = []) {
        try {
            this.logWillBePublishedEvent(evt, receivers);
            //送給UI的方式是放EventReceiver.CLIENT
            if (receivers.find(r => r.id === IEventHub_1.EventReceiver.CLIENT.id)) {
                //用Rx把Event在本地端傳播
                const evtCategorySubject = this._subjects.get(evt.category);
                if (evtCategorySubject)
                    evtCategorySubject.next(evt.toLocalEvent());
                //處理完送給Client後拿掉
                receivers = receivers.filter(r => r !== IEventHub_1.EventReceiver.CLIENT);
            }
            //除了CLIENT外沒有其他接收者就免送
            if (receivers.length === 0)
                return;
            await this.InternalPublishEventAsync(evt, receivers);
        }
        catch (error) {
            const errorMsg = `Publishing ${evt.category}.${evt.name} event failed, reason =${error}`;
            this._logger.error(errorMsg, error);
            this.errorOccurred.emitEvent(evt.category, [new IEventHub_1.EventHubError(errorMsg, error)]);
        }
    }
    async InternalPublishEventAsync(evt, receivers = []) {
        const eventJson = JSON.stringify(evt);
        for (const r of receivers) {
            const channelName = `${ProtocolConstant_1.RTC_CHATTING_EVENT_CHANNEL_NAME}/${r.name}`;
            await this._langyan.publishToChannelAsync(channelName, eventJson);
        }
    }
    logWillBePublishedEvent(evt, receivers = []) {
        //本地端通知自己的Client的TeacherTimePassed的DomainEvent太多，目前先不顯示，之後再看有沒有什麼好的作法。
        // if (evt.Name == "TeacherTimePassed"
        //     && receivers.Any(r => r.Id == EventReceiver.CLIENT.Id)
        //     && receivers.Count() == 1)
        //     return;
        this._logger.info(`Publish Event=${evt.category}.${evt.name} to [${receivers}], EntityId=${evt.entityId}.Id=${evt.id}`);
        //this._logger.debug(`Publish Event detail: ${evt}}`);
    }
    registerEventHandler(category, handler) {
        this._eventHandlerDic.set(category, handler);
        this._logger.info(`Register ${category} event handler with a handler`);
    }
    unRegisterEventHandler(category) {
        if (!this._eventHandlerDic.has(category))
            return;
        else {
            const willbeUnregister = this._eventHandlerDic.get(category);
            this._eventHandlerDic.delete(category);
            this._logger.info(`UnRegister ${category} event handler.`);
        }
    }
    subscribeEventHandler(category, eventName, evtHandler, onError) {
        if (!this._subjects.has(category)) {
            const newSubject = new rxjs_1.Subject();
            this._subjects.set(category, newSubject);
        }
        const evtSubject = this._subjects.get(category);
        if (!evtSubject)
            throw new IEventHub_1.EventHubError(`No ${category} Subject`);
        const subscription = evtSubject
            .pipe(operators_1.filter(evt => evt.category === category), operators_1.filter(evt => evt.name === eventName))
            .subscribe({
            next: (evt) => {
                try {
                    evtHandler(evt);
                }
                catch (error) {
                    this._logger.error(`Handling ${evt.category}.${evt.name} event failed, reason =${error}`, error);
                    if (onError)
                        onError(error);
                }
            },
            error: (error) => {
                if (onError != null)
                    onError(error);
            }
        });
        return subscription;
    }
    subscribeEventAsyncHandler(category, eventName, evtHandler, onError) {
        if (!this._subjects.has(category)) {
            const newSubject = new rxjs_1.Subject();
            this._subjects.set(category, newSubject);
        }
        const evtSubject = this._subjects.get(category);
        if (!evtSubject)
            throw new IEventHub_1.EventHubError(`No ${category} Subject`);
        const subscription = evtSubject
            .pipe(operators_1.filter(evt => evt.category === category), operators_1.filter(evt => evt.name === eventName))
            .subscribe({
            next: async (evt) => {
                try {
                    await evtHandler(evt);
                }
                catch (error) {
                    this._logger.error(`Handling ${evt.category}.${evt.name} event failed, reason =${error}`, error);
                    if (onError)
                        onError(error);
                }
            },
            error: (error) => {
                if (onError != null)
                    onError(error);
            }
        });
        return subscription;
    }
    countOfRemoteEventHandler() {
        return this._eventHandlerDic.size;
    }
    countOfLocalEventHandler() {
        return this._subjects.size;
    }
    receiveEvent(evt) {
        throw new Error("Not Implemented.");
    }
    async receiveEventAsync(evt) {
        this._logger.info(`Receive Event=${evt.category}.${evt.name}.EntityId=${evt.entityId}.Id=${evt.id}`);
        //this._logger.debug(`Receive Event detail: ${evt}`);
        try {
            const evtHandler = this._eventHandlerDic.get(evt.category);
            if (evtHandler) {
                await evtHandler.handleEventAsync(evt);
            }
            else {
                this._logger.warn(`No handler for ${evt.category}.${evt.name} event. Something wrong??`);
            }
            // 遠端送過來的DomainEvent用Rx來送，會需要區分本地端Event與遠端Event，邏輯會不好處理所以不用
            //if (!subjects.ContainsKey(evt.Category))
            //{
            //    _logger.Warn(() => $"No handler for  {evt.GetType().Name} event. Something wrong??");
            //    return;
            //}
            //subjects[evt.Category].OnNext(evt);
        }
        catch (error) {
            const errorMsg = `Handling ${evt.category}.${evt.name} event failed, reason=${error}`;
            this._logger.error(errorMsg, error);
            this.errorOccurred.emitEvent(evt.category, [new IEventHub_1.EventHubError(errorMsg, error)]);
        }
    }
    async eventChannelHandler(e) {
        await this.receiveEventAsync(new DomainEvent_1.DomainEvent(e));
    }
    static getEventChannelName(username) {
        return `${ProtocolConstant_1.RTC_CHATTING_EVENT_CHANNEL_NAME}/${username}`;
    }
}
exports.ClientEventHub = ClientEventHub;
//# sourceMappingURL=ClientEventHub.js.map